import { CfJsonVariables } from '../../types';

const round1Decimal = (value?: number) => (typeof value === 'number' ? Math.round(value * 10) / 10 : null);

const getVariableData = ({ variablesList, key, latestIndex }: { variablesList: CfJsonVariables[]; key: string; latestIndex: number }) => {
    const data = variablesList.find((v) => v[key]);

    return data?.[key].data[latestIndex] || '-';
};

const getObsData = ({ variablesList, latestIndex }: { variablesList: CfJsonVariables[]; latestIndex: number }) => ({
    PT1M: {
        windSpeed: {
            min: round1Decimal(getVariableData({ variablesList, key: 'windlul_01mnmin', latestIndex })),
            avg: round1Decimal(getVariableData({ variablesList, key: 'windspd_01mnavg', latestIndex })),
            max: round1Decimal(getVariableData({ variablesList, key: 'windgst_01mnmax', latestIndex })),
        },
        windDirection: {
            min: round1Decimal(getVariableData({ variablesList, key: 'windccw_01mnmax', latestIndex })), // windccw_01mnmax || windccw_01mnmin
            avg: round1Decimal(getVariableData({ variablesList, key: 'winddir_01mnavg', latestIndex })),
            max: round1Decimal(getVariableData({ variablesList, key: 'windcw__01mnmax', latestIndex })),
        },
    },
    PT10M: {
        windSpeed: {
            min: round1Decimal(getVariableData({ variablesList, key: 'windlul_10mnmin', latestIndex })),
            avg: round1Decimal(getVariableData({ variablesList, key: 'windspd_10mnavg', latestIndex })),
            max: round1Decimal(getVariableData({ variablesList, key: 'windgst_10mnmax', latestIndex })),
        },
        windDirection: {
            min: round1Decimal(getVariableData({ variablesList, key: 'windccw_10mnmax', latestIndex })),
            avg: round1Decimal(getVariableData({ variablesList, key: 'winddir_10mnavg', latestIndex })),
            max: round1Decimal(getVariableData({ variablesList, key: 'windcw__10mnmax', latestIndex })),
        },
    },
    PT1H: {
        windSpeed: {
            min: '-',
            avg: round1Decimal(getVariableData({ variablesList, key: 'windspd_01hravg', latestIndex })),
            max: round1Decimal(getVariableData({ variablesList, key: 'windgst_01hrmax', latestIndex })),
        },
        windDirection: {
            min: round1Decimal(getVariableData({ variablesList, key: 'windccw_01hrmax', latestIndex })),
            avg: round1Decimal(getVariableData({ variablesList, key: 'winddir_01hravg', latestIndex })),
            max: round1Decimal(getVariableData({ variablesList, key: 'windcw__01hrmax', latestIndex })),
        },
    },
});

export default getObsData;
